import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "search"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_overlay_panel = _resolveComponent("app-overlay-panel")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref: "targetRef",
      class: "dropdown-container",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createElementVNode("div", {
        class: "dropdown-value",
        style: _normalizeStyle({ height: _ctx.height })
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.valueRef), 1)
      ], 4),
      _createElementVNode("button", {
        disabled: _ctx.disabled,
        type: "button",
        class: _normalizeClass(["toggle-btn", { withTitle: _ctx.isTitle }])
      }, " ▼ ", 10, _hoisted_2),
      (_ctx.targetRef)
        ? (_openBlock(), _createBlock(_component_app_overlay_panel, {
            key: 0,
            visible: _ctx.visible,
            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
            target: _ctx.targetRef
          }, {
            default: _withCtx(() => [
              (_ctx.isSearch)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_app_input, {
                      modelValue: _ctx.searchValue,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
                      placeholder: "search",
                      icon: ['fas', 'search'],
                      "is-label": false,
                      onFocus: _ctx.focusInput,
                      onBlur: _ctx.focusOutInput
                    }, null, 8, ["modelValue", "onFocus", "onBlur"])
                  ]))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3
          }, 8, ["visible", "target"]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}